import {
  createFrontendPlugin,
  PageBlueprint,
  PluginHeaderActionBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiGithubFill } from '@remixicon/react';
import { rootRouteRef } from './routes';

export const githubDashboardPage = PageBlueprint.make({
  params: {
    title: 'GitHub Dashboard',
    icon: <RiGithubFill />,
    path: '/dashboards/github',
    routeRef: rootRouteRef,
    loader: () => import('./app').then(m => <m.GithubDashboardRoot />),
  },
});

export const headerActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () =>
        import('./components/header-actions').then(m => <m.HeaderActions />),
    }),
});

export const githubDashboardPlugin = createFrontendPlugin({
  pluginId: 'github-dashboard',
  extensions: [githubDashboardPage],
  routes: {
    root: rootRouteRef,
  },
});
